import { useState, type FC, type ReactNode } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  ResendEmailModalContent,
  type IResendEmailModalContentProps,
} from "@tenant/self-serve";
import { Dialog, DialogContent, DialogTrigger } from "@tenant/ui";
import type { ClassValue } from "clsx";

export interface ResendEmailModalProps
  extends Omit<IResendEmailModalContentProps, "onClose"> {
  className?: ClassValue;
  title: ReactNode;
  initialValue?: string;
  disabled?: boolean;
}

export const ResendEmailModal: FC<ResendEmailModalProps> = (props) => {
  const { title, disabled, ...modalContentProps } = props;
  const { t } = useI18nContext();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger disabled={disabled}>{title}</DialogTrigger>
      <DialogContent title={t("core-self-serve.resend-email.form.title")}>
        <ResendEmailModalContent {...modalContentProps} />
      </DialogContent>
    </Dialog>
  );
};
